import { queryKeys } from '@query/keys'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { useCallback } from 'react'

import { useAccountReadContext } from '@context/AccountContextContext'
import { useSessionLanguage } from '@context/SessionSettingsContext'

import { useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'

import { IntroducingBrokerDetailsDto } from '@model/IntroducingBrokerDetailsDto'

interface IntroducingBrokerById {
  data?: IntroducingBrokerDetailsDto
  isLoading: boolean
  forceRefresh: (skipLoadingFlag?: boolean) => void
}

export const useIntroducingBrokerById = (): IntroducingBrokerById => {
  const { account } = useAccountReadContext()
  const locale = useSessionLanguage()
  const apiClient = useApiClient(ClientApiClient)
  const queryClient = useQueryClient()

  const ibId = account?.clientIntroducingBroker?.id

  const { data, isLoading } = useQuery({
    queryKey: queryKeys.ib.details(ibId, locale),
    queryFn: () => apiClient.getIntroducingBrokerById(locale, ibId!),
    enabled: !!ibId,
  })

  const forceRefresh = useCallback(() => {
    queryClient.invalidateQueries({
      queryKey: queryKeys.ib.details(ibId, locale),
    })
  }, [queryClient, ibId, locale])

  return { data, isLoading, forceRefresh }
}
